import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withFormik, Form, Field} from 'formik';

class Settings extends Component {

    // Renders
    renderUsernameForm = () => (
        <div className="form-group">
            <label>Username</label>
            <Field
                type="text"
                name='username'
                className="form-control"
            />
        </div>
    );

    renderCurrentPass = () => (
        <div className="form-group">
            <label>Current Password</label>
            <Field
                type="password"
                name='password'
                className="form-control"
                disabled
            />
        </div>
    );

    renderNewPass = () => (
        <div className="form-group">
            <label>New Password</label>
            <Field
                type="password"
                name='updatedPassword'
                className="form-control"
            />
        </div>
    );

    renderNewPassConfirm = (errors, touched) => (
        <div className="form-group">
            <label>Confirm New Password</label>
            <Field
                type="password"
                name='updatedPassword2'
                className="form-control"
            />
            {
                touched.updatedPassword2
                && errors.updatedPassword2
                && <p>{errors.updatedPassword2}</p>
            }
        </div>
    );

    render() {
        const {
            errors,
            touched,
            handleSubmit,
        } = this.props;

        return (

        <Form className="">
            <div className="form-section">
                <h3 className="form-heading">
                    <i className="zmdi zmdi-settings sm-right20 form-icon"/>
                    Update Login Info
                </h3>
                <div className="form-section-body">
                    <div className="row">
                    <div className="col-md-12">
                        
                        {this.renderCurrentPass()}
                        {this.renderNewPass()}
                        {this.renderNewPassConfirm(errors, touched,)}
                        </div>

                    </div>   
                    <div className="row">
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="btn btn-base"
                            // disabled={isSubmitting}
                            onClick={handleSubmit}
                        >
                            Save Info
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            
        
        </Form>
        )
    }
};

const SettingsFormSide = withFormik({
    mapPropsToValues({ parentProps, username, password, updatedPassword, updatedPassword2 }) {
        return {
            username: username || parentProps.user.user.username || '',
            password: password || parentProps.password || '',
            updatedPassword: updatedPassword || '',
            updatedPassword2: updatedPassword2 || '',
        };
    },

    handleSubmit(values, {resetForm, setErrors, setSubmitting, isSubmitting, props}) {
        setTimeout(() => {
            if (values.updatedPassword !== values.updatedPassword2) {
                setErrors({ updatedPassword2: 'Passwords do not matches' })
            } else {
                let newUser = {};

                if(values.username){
                    newUser.username = values.username;
                }

                if(values.updatedPassword2){
                    newUser.password = values.updatedPassword2;
                }
                props.updateUser(
                    newUser
                );
            }
        }, 200)
    },

})(Settings);

SettingsFormSide.propTypes = {
    username: PropTypes.string,
    password: PropTypes.string,
};

export default SettingsFormSide;


// WEBPACK FOOTER //
// ./src/components/Settings/SettingsFormSide.js